// 框架内存通用管理组件
import memory from './components/memory';
// 输出程序配置
export default {
    appSetting: {
        components: {
            memory
        }
    }
};


// WEBPACK FOOTER //
// ./src/vendor/dependency/memory/load.js